// Brand. The public name may change after trademark clearance: it lives only in BRAND_NAME,
// the Wordmark is plain text in the brand type style, and the Mark carries no letters.
// Keep src/brand/mark.svg and the geometry below identical (a test checks).
import type { HTMLAttributes, SVGProps } from "react";
import { cx } from "../presentation.tsx";

export const BRAND_NAME = "Vavr";

export { markGeometry } from "./geometry.ts";
import { markGeometry } from "./geometry.ts";

export interface MarkProps extends SVGProps<SVGSVGElement> {
  size?: number | string;
  /** Accessible name; pass "" when the mark sits next to the wordmark. */
  label?: string;
}

export function Mark({ size = 32, label = BRAND_NAME, className, ...rest }: MarkProps) {
  const g = markGeometry, m = g.mark;
  return (
    <svg
      viewBox="0 0 1024 1024" width={size} height={size} className={cx("pmu-mark", className)} focusable="false"
      {...(label ? { role: "img", "aria-label": label } : { "aria-hidden": true })} {...rest}
    >
      <rect width="1024" height="1024" rx="256" fill={g.tile} />
      <g transform={`matrix(${m.s} 0 0 ${m.s} ${m.tx} ${m.ty})`}>
        <path d={g.vPath} fill={g.cream} />
        <path d={g.tipPath} fill={g.marigold} />
      </g>
    </svg>
  );
}

export interface WordmarkProps extends HTMLAttributes<HTMLSpanElement> {
  /** Show the mark before the name. */
  withMark?: boolean;
  /** Override the name (e.g. for a white-label preview). */
  name?: string;
}

export function Wordmark({ withMark = false, name = BRAND_NAME, className, ...rest }: WordmarkProps) {
  return (
    <span className={cx("pmu-wordmark", className)} {...rest}>
      {withMark && <Mark size="1.4em" label="" />}
      <span className="pmu-wordmark__name">{name}</span>
    </span>
  );
}
